
// Packages
import axios from "axios";

const sendExamConfirmationEmail = (timeslot_id, test_taker_id) => {
    const token = localStorage.getItem("access_token");

    //axios call to Django view
    axios
    .post(`${process.env.REACT_APP_API_BASE_URL}api/send-exam-confirmation-email/`, {
        timeslot_id: timeslot_id,
        test_taker_id: test_taker_id,
    }, {
        headers : {
            Authorization: `Bearer ${token}`
        }
    })
    .then((response) => {
        if (response.status === 200) {
            console.log("Exam Confirmation Email sent successfully:", response.data);
        }
    })
    .catch((error) => {
        console.log(error)
    });

};

export default sendExamConfirmationEmail;